module.exports = __webpack_public_path__ + "media/shared/assets/fonts/PlusJakartaSans/PlusJakartaSans-Bold-5f53f86aea22967100fc7fb8e53eb842.woff2";